module.exports = __webpack_public_path__ + "static/img/nodata.ad0867b7.png";